import { intlLocaleFor } from "./formatMoney";
import { EMPTY } from "./dateTime";

/**
 * A percentage in the UI language's own form: "0.50%" (en) / "0,50 %" (fr, es). The space in
 * fr and es is the narrow no-break space ICU emits. Callers pass percent units (0.5 is half a
 * percent) and never append a literal "%": the sign travels with the number, so a dictionary
 * sentence carries only the placeholder.
 *
 * A missing or non-finite input is `EMPTY`, never "NaN%".
 */
export function formatPercent(pct, lang, digits = 2) {
  if (pct === null || pct === undefined || pct === "") return EMPTY;
  const n = Number(pct);
  if (!Number.isFinite(n)) return EMPTY;
  return new Intl.NumberFormat(intlLocaleFor(lang), {
    style: "percent",
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(n / 100);
}
